import { render, staticRenderFns } from "./onlyContent.vue?vue&type=template&id=02aede2b&scoped=true&"
import script from "./onlyContent.vue?vue&type=script&lang=js&"
export * from "./onlyContent.vue?vue&type=script&lang=js&"
import style0 from "./onlyContent.vue?vue&type=style&index=0&id=02aede2b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02aede2b",
  null
  
)

export default component.exports